import React from 'react'
import { css } from '@emotion/core'
import { useTranslation, Trans } from 'react-i18next'
import { Separator, LayoutBand, Image, H3, H5, Paragraph, colors } from '@fs/zion-ui'

import { cdnRoot } from '../../services/services'

export default function PreserveTempleMemory() {
  const [t] = useTranslation()

  const pageStyles = css`
    [data-text-color-alert] {
      color: ${colors.red60};
    }
  `
  return (
    <LayoutBand maxWidth="xs" css={pageStyles}>
      <Separator />
      <Image
        alt={t(
          'informational.temple.prepare.youth.ancestor.image-alt',
          'A young woman prepares names for the temple with her mother.'
        )}
        src={`${cdnRoot}/connect/informational/youth-temple-preserve-memory.png`}
      />
      <Separator />

      <H3>{t('informational.temple.prepare.temple.memory.heading', 'Preserve a Temple Memory')}</H3>
      <Separator />
      <Paragraph>
        {t(
          'informational.temple.prepare.tmeple.memory.paragraph1',
          "After your child participates in temple baptisms for the first time, it's nice to take some time together to reflect on the experience and make a record of it. See below for the principle behind this and then an easy way to record it."
        )}
      </Paragraph>
      <Separator />
      <H5>
        {t('informational.temple.prepare.temple.memory.subheader', 'Preserving Memories—and Strengthening Faith')}
      </H5>
      <Separator />
      <Paragraph>
        {t(
          'informational.temple.prepare.temple.memory.paragraph2',
          "The prophet Alma taught the importance of remembering the Lord's mercy and goodness (see Alma 5, for example). As we remember sacred and joyful experiences, we can continue to learn from them over time, strengthening our faith in Jesus Christ. In a general conference address, President Henry B. Eyring urged us “to find ways to recognize and remember God's kindness” (“O Remember, Remember,” Ensign, November 2007, 67). He also taught that remembering how we have been blessed will build our testimonies and strengthen us in those moments when we “need to remember how much God loves us and how much we need him.”"
        )}
      </Paragraph>
      <Separator />
      <Paragraph>
        {t(
          'informational.temple.prepare.temple.memory.paragraph3',
          'As we record our feelings about significant events in our lives, the meaning and power of those memories can be preserved—for ourselves and for others.'
        )}
      </Paragraph>
      <Separator />
      <H5 data-text-color-alert>
        {t(
          'informational.temple.prepare.temple.memory.activity-prompt',
          'ACTIVITY: Help your child preserve a memory about his or her first trip to the temple.'
        )}
      </H5>
      <Separator />

      <Paragraph>
        {t(
          'informational.temple.prepare.temple.memory.paragraph4',
          'Go to the Family Tree app or FamilySearch website (be sure your child uses his or her own log-in information) and open the Memories tab. Follow the prompts for uploading a written story, photo or audio recording.'
        )}
      </Paragraph>
      <Separator />
      <Paragraph>
        {t(
          'informational.temple.prepare.temple.memory.paragraph5',
          'Here are a few questions to help your child get started:'
        )}
      </Paragraph>
      <Separator />
      <ol>
        <Trans i18nKey="informational.temple.prepare.temple.memory.paragraph6">
          <li>Which temple did you visit and when?</li>
          <li>Did anyone go with you?</li>
          <li> How do you think the people you were baptized and confirmed for feel about these ordinances?</li>
          <li>How did you feel?</li>
          <li>Are there any blessings you hope to receive by serving in the temple?</li>
        </Trans>
      </ol>
      <Separator />
    </LayoutBand>
  )
}
